export const HOME_TYPE = {
    BRAND_NAME : "BRAND_NAME",
    CONTACT_NAME : "CONTACT_NAME",
    CONTACT_EMAIL : "CONTACT_EMAIL",
    CONTACT_PHONE : "CONTACT_PHONE",
    CONTACT_MESSAGE : "CONTACT_MESSAGE",
}